__turbopack_context__.v({
  "captionWithMB": "spec_W_captionWithMB",
  "h1": "spec_W_h1",
  "h2": "spec_W_h2",
  "sectionPadding": "spec_W_sectionPadding",
  "subtitle": "spec_W_subtitle",
});
